<template>
  <b-modal
    :active="true"
    :can-cancel="['escape', 'x', 'outside']"
    @close="onClose"
  >
    <div class="content">
      <div class="header">
        <template>
          <h1 class="title">{{ $t('create_work_instruction') }}</h1>
        </template>
      </div>

      <div class="columns" v-for="item in items" :key="item.key">
        <div class="column">
          <b-field>
            <b-checkbox v-model="item.checked" @input="onCheckboxChange(item)">
              {{ item.label }}
            </b-checkbox>
          </b-field>
        </div>
        <div class="column is-three-quarters">
          <b-field>
            <b-input v-model="item.title" :disabled="!item.checked"></b-input>
          </b-field>
        </div>
      </div>

      <footer class="footer-buttons">
        <b-button label="Cancel" @click="onClose" type="is-danger" />
        <b-button label="Save" @click="onSave" type="is-success" />
      </footer>
    </div>
  </b-modal>
</template>
<script>
export default {
  name: 'CreateWIPackageModal',

  props: {
    job: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      items: [
        { key: 'inspection', label: 'Inspection', checked: false, title: '' },
        {
          key: 'repair',
          label: 'Repair & Reassembly',
          checked: false,
          title: '',
        },
        { key: 'rework', label: 'Rework', checked: false, title: '' },
        { key: 'warranty', label: 'Warranty', checked: false, title: '' },
        { key: 'other', label: 'Other', checked: false, title: '' },
      ],
    };
  },

  methods: {
    onCheckboxChange(item) {
      if (item.checked && !item.title) {
        const isEditor = this.$route.name.includes('editor');
        if (isEditor) {
          item.title = item.label;
        } else {
          const jobNumber =
            this.job?.projectInfoText ||
            this.job?.workOrderNumber ||
            this.job?.documentNumber ||
            '';
          item.title = jobNumber ? `${item.label} - ${jobNumber} ` : item.label;
        }
      }
    },
    onClose() {
      this.$emit('close');
    },
    onSave() {
      const packages = this.items
        .filter((item) => item.checked)
        .map((item) => ({
          title: item.title,
          sortOrder: this.items.indexOf(item),
        }));
      this.$emit('save', packages);
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  background: white;
  border-radius: 10px;
  padding: 20px;
  gap: 10px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.header {
  display: flex;
  justify-content: space-between;
}

.footer-buttons {
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
}

.columns {
  align-items: center;
}
</style>
